import { useEffect, useState } from "react"
import { useStore } from "stores/utils/use-store"
import { Button, Form, InputNumber, Typography } from "antd"
import { observer } from "mobx-react"
import { notifications } from "notifications"
import { BuffPlayV2ConfigType, ConfigItem } from "domains/managingJson/store/types"
import InAppReviews from "./InAppReviews"
const { Title } = Typography

export const BuffPlayV2Config = observer(() => {
  const { dataStore: { managingJsonStore } } = useStore()
  const [data, setData] = useState<BuffPlayV2ConfigType | undefined>()
  const [form] = Form.useForm<BuffPlayV2ConfigType>()

  useEffect(() => {
    managingJsonStore.getData()
  }, [managingJsonStore])

  useEffect(() => {
    const buffPlayV2ConfigData = managingJsonStore?.itemTypes?.find(
      item => item.type === "buffPlayV2Config",
    )
    if (buffPlayV2ConfigData) {
      const data = buffPlayV2ConfigData.data as BuffPlayV2ConfigType
      setData(data)
      form.setFieldsValue({
        reviewRequestsEnabled: data.reviewRequestsEnabled,
        sentrySampleRate: data.sentrySampleRate,
        inAppReviews: data.inAppReviews,
      })
    }
  }, [form, managingJsonStore.itemTypes])

  const onFinishHandler = async() => {
    const { reviewRequestsEnabled, sentrySampleRate, inAppReviews }
      = form.getFieldsValue()

    managingJsonStore.funcAfterSuccess = async() => {
      notifications.success("Saved successfully")
      await managingJsonStore.getData()
    }

    const config = {
      name: "buffPlayV2Config",
      type: "buffPlayV2Config",
      data: { reviewRequestsEnabled, sentrySampleRate, inAppReviews },
    } satisfies ConfigItem<"buffPlayV2Config">

    data ? await managingJsonStore.update(config) : await managingJsonStore.create(config)
  }

  return (
    <Form onFinish={onFinishHandler} form={form}>
      <Title level={2}>Buff Play V2 Config</Title>
      <Form.Item name="sentrySampleRate" label="Sentry Sample Rate (0-1)">
        <InputNumber min={0} max={1} step={0.01} />
      </Form.Item>

      <InAppReviews />

      <Button type="primary" htmlType="submit" style={{ marginBottom: "2rem" }}>
        Save All
      </Button>
    </Form>
  )
})
